import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface BlogHeroProps {
  onSearchChange: (value: string) => void;
  searchQuery: string;
}

const BlogHero = ({ onSearchChange, searchQuery = '' }: BlogHeroProps) => {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <Icon name="SparklesIcon" size={20} className="text-primary" />
            <span className="text-sm font-medium text-primary">AI Insights & Resources</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-foreground mb-6">
            Kenniscentrum voor{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
              AI-transformatie
            </span>
          </h1>
          
          <p className="text-lg sm:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto">
            Praktische inzichten, implementatiegidsen en marktanalyses voor Benelux MKB-bedrijven die AI willen omarmen
          </p>
          
          <div className="relative max-w-2xl mx-auto">
            <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full"></div>
            <div className="relative glassmorphic rounded-2xl p-2">
              <div className="flex items-center space-x-3">
                <Icon name="MagnifyingGlassIcon" size={24} className="text-muted-foreground ml-4" />
                <input
                  type="text"
                  placeholder="Zoek artikelen, gidsen, of onderwerpen..."
                  value={searchQuery ?? ''}
                  onChange={(e) => onSearchChange(e.target.value)}
                  className="flex-1 bg-transparent border-none outline-none text-foreground placeholder:text-muted-foreground py-4 text-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHero;